import { formatResult } from '../../../helper/recheck';

const TumblingEResult = ({ test, result }) => {
  const hasEyePassed = (eyeKey) => {
    let correctAnswersCount = 0;
    const ids = [8, 9];

    result.testResultData[eyeKey].forEach((eyeResult) => {
      if (eyeResult.correct && ids.includes(eyeResult.logmar.id)) {
        correctAnswersCount++;
      }
    });

    return correctAnswersCount > 1;
  };

  const resultTable = (eyeKey, title) => {
    return (
      <tr>
        <td className='font-weight-bold w-25'>{title}</td>
        {Array.isArray(result.testResultData[eyeKey]) && result.testResultData[eyeKey].length ? (
          <td>{hasEyePassed(eyeKey) ? formatResult('Visual Acuity', true) : formatResult('Visual Acuity', false)}</td>
        ) : (
          <td>Not completed</td>
        )}
      </tr>
    );
  };
  return (
    <table className='table table-bordered w-75'>
      <thead>
        <tr>
          <th colSpan='2' className='text-center bg-primary-ibis'>
            {test}
          </th>
        </tr>
      </thead>
      <tbody>
        {!result ? (
          <tr>
            <td>No results found.</td>
          </tr>
        ) : (
          <>
            {resultTable('right-eye', 'OD')}
            {resultTable('left-eye', 'OS')}
          </>
        )}
      </tbody>
    </table>
  );
};

export default TumblingEResult;
